
import React, { } from "react";
import { ConfirmModal } from "../..";
import { useAicoConnection } from "../_ToolsComponents/aicoConnectionContext";
import { SetTableFromDBResponse, SetTableFromDBArgs, SET_TABLE_FROM_DB } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/setTableFromDB";
import { useMutation } from "@apollo/client";

interface ResetTableProps {
	closeModal: () => void;
	onSuccess: () => void;
	tableId: number
}

export default function ResetTableModal({ closeModal, onSuccess, tableId }: ResetTableProps) {
	const { state: connectionState } = useAicoConnection();

	const [resetTableFetch, { data: resetTableData, loading: resetTableLoading, error: resetTableError, reset: resetState }] = useMutation<SetTableFromDBResponse, SetTableFromDBArgs>(SET_TABLE_FROM_DB, {
		fetchPolicy: "network-only"
	});

	async function handleResetTable() {
		if (!connectionState.deviceConnection) {
			return;
		}

		const result = await resetTableFetch({ variables: {...connectionState.deviceConnection, tableid: tableId},  });
		if (result.data?.controller.setTableFromDb?.success) {
			onSuccess();
		}
	}

	function handleCloseModal() {
		resetState();
		closeModal();
	}

	return (
		<ConfirmModal
			disclaimer="This action will reset the table on the LAN Controller to be up to date with the server, this action is irreversible!"
			onCancel={handleCloseModal}
			onConfirm={handleResetTable}
			message={
				(resetTableError || (resetTableData?.controller && !resetTableData.controller.setTableFromDb?.success)) ? "ERROR: Failed To Reset Table" :
				(!resetTableLoading && !resetTableError && resetTableData?.controller.setTableFromDb?.success) ? "Succesfully Reset Table" : undefined
			}
			loading={resetTableLoading}
		/>
	);
}